import * as React from 'react'
import type {UserProfile} from '../types/types'
import {Avatar} from '@upgrowth/react-fulcrum'
import defaultProfile from './default-profile.svg'

export default ({avatar, name, className}: UserProfile) => (
  <Avatar img={window.rewriteImageUrl(avatar) || defaultProfile} alt={name} size="small" className={className}/>
)
